<template>
  <div class="card card-style has-width-500">
    <div class="card-header">
      <div class="card-header-title">
        <h2>
          Dangerous Goods Management Web Portal
          <br>
          <span style="font-size: 16px; font-weight: normal;">- Signup -</span>
        </h2>
      </div>
    </div>
    <div>
      <form action method="POST" @submit.prevent="signup">
        <validation-observer
          ref="signupObserver"
          tag="div"
          v-slot="{invalid, valid, untouched, errors}"
        >
          <div class="columns flex-column has-margin-top-10 has-padding-20">
            <!-- Name of new shipper -->
            <div class="column is-12">
              <input-with-validation
                :name="'name'"
                :errorLabel="'name'"
                :label="'Full Name'"
                rules="required"
                v-model="full_name"
                :type="'text'"
                :vid="'name'"
              ></input-with-validation>
            </div>

            <!-- Username of new shipper -->
            <div class="column is-12">
              <input-with-validation
                :name="'Username'"
                :errorLabel="'name'"
                :label="'Username'"
                rules="required"
                v-model="user_name"
                :type="'text'"
                :vid="'name'"
              ></input-with-validation>
            </div>

            <!-- Email of new shipper -->
            <div class="column is-12">
              <input-with-validation
                :name="'email'"
                :errorLabel="'email'"
                :label="'Email Address'"
                rules="required|email"
                v-model="email"
                :type="'text'"
                :vid="'email'"
              ></input-with-validation>
            </div>

            <!-- password of new shipper -->
            <div class="column is-12">
              <input-with-validation
                :name="'password'"
                :errorLabel="'password'"
                :rules="'required|min:6'"
                :label="'Password'"
                v-model="password"
                :type="'password'"
                :vid="'password'"
                :password-reveal="true"
              ></input-with-validation>
            </div>

            <div class="column is-12">
              <input-with-validation
                :name="'password_confirmation'"
                :errorLabel="'password'"
                :rules="'required|confirmed:password|min:6'"
                :label="'Confirm Password'"
                v-model="password_confirmation"
                :type="'password'"
                :password-reveal="true"
              ></input-with-validation>
            </div>

            <div class="column is-12">
              <button
                class="button is-primary is-full-width has-margin-bottom-20"
                :class="{'is-loading': loading, 'is-disabled': loading}"
              >
                <span>Signup</span>
              </button>
            </div>
          </div>
        </validation-observer>
      </form>
    </div>
  </div>
</template>

<script>
import authMutations from "@/modules/rootModule/api/graphql/mutations/Authentication";
import InputWithValidation from "@/modules/commonModule/components/formInputs/inputWithValidation";
import { ValidationObserver, ValidationProvider } from "vee-validate";
/**
 * This component is the Login card used to authenticate a user.
 */
export default {
  name: "SignupCard",

  components: { InputWithValidation, ValidationObserver },

  data() {
    return {
      full_name: "",
      user_name: "",
      email: "",
      password: "",
      password_confirmation: "",
      loading: false
    };
  },

  methods: {
    /**
     * Signup the shipper
     */
    signup: async function() {
      const isValid = await this.$refs.signupObserver.validate();
      if (!isValid) {
        return;
      }

      const signupInput = {
        full_name: this.full_name,
        password: this.password,
        email: this.email,
        user_name: this.user_name,
        user_type: "SHIPPER"
      };
      this.loading = true;

      this.$apollo
        .mutate({
          mutation: authMutations.signupMutation,
          variables: {
            input: signupInput
          }
        })
        .then(response => {
          const shipper_name = response.data.CreateShipperUser.full_name;
          this.$toast.open({
            duration: 6000,
            message: `${shipper_name} Your Sign Up was successful, and a verification email has been sent to your provided e-mail address.`,
            type: "is-black",
          });

          this.full_name = "";
          this.user_name = "";
          this.email = "";
          this.password = "";
          this.password_confirmation = "";

          this.$router.push({ name: "login", params: { signUpSuccessful: true } });
          this.$parent.close();
        })
        .catch(err => {
          this.$toast.open({
            duration: 5000,
            message: "Could not sign you up at the moment, try again later",
            type: "is-danger"
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>


<style scoped>
.card-header-title,
h2 {
  font-family: "Poppins";
  text-align: center;
  justify-content: center;
  color: #3c5081;
  font-size: 1.1em;
  font-weight: bold !important;
  max-width: 300px;
  margin: 0 auto;
}

.card-style {
  padding: 1em;
  border: 1px solid #3c5081;
}
</style>
